// Route-chunk loaders shared by React.lazy (App.js) and the idle/hover prefetchers, so every page is in memory before it is clicked.
export const ROUTE_LOADERS = {
  "/about": () => import("@/pages/About"),
  "/team": () => import("@/pages/Team"),
  "/team/": () => import("@/pages/AdvisorProfile"),
  "/services": () => import("@/pages/Services"),
  "/platform": () => import("@/pages/Platform"),
  "/media": () => import("@/pages/Media"),
  "/events": () => import("@/pages/Events"),
  "/careers": () => import("@/pages/Careers"),
  "/guides": () => import("@/pages/Guides"),
  "/guide": () => import("@/pages/Guide"),
  "/article": () => import("@/pages/Article"),
  "/legal": () => import("@/pages/Legal"),
  "/beyond-referrals": () => import("@/pages/funnel/BeyondReferrals"),
};

const HERO_IMAGES = ["/img/about-team.webp", "/img/team-hero.webp", "/img/services-hero.webp", "/img/media-hero.webp", "/img/leader-award.webp", "/img/team-group.webp"];

const done = new Set();
const run = (key) => {
  if (done.has(key) || !ROUTE_LOADERS[key]) return Promise.resolve();
  done.add(key);
  return ROUTE_LOADERS[key]().catch(() => done.delete(key));
};

export const prefetchRoute = (path = "") => {
  const p = path.split(/[#?]/)[0];
  if (p.startsWith("/team/")) return run("/team/");
  if (p === "/disclaimer" || p === "/privacy-policy") return run("/legal");
  if (ROUTE_LOADERS[p]) return run(p);
  if (/^\/(zh\/)?[a-z0-9-]+-singapore$/.test(p)) return run("/guide");
  if (p.startsWith("/articles/")) return run("/article");
  return Promise.resolve();
};

let warmed = false;
export const prefetchAllRoutes = () => {
  if (warmed || typeof window === "undefined") return;
  warmed = true;
  const go = async () => {
    for (const key of Object.keys(ROUTE_LOADERS)) await run(key);
    HERO_IMAGES.forEach((src) => { const img = new Image(); img.decoding = "async"; img.src = src; });
  };
  if ("requestIdleCallback" in window) window.requestIdleCallback(go, { timeout: 4000 });
  else setTimeout(go, 1500);
};
